import { api, apiBlob } from './client';
import { UsageLimits, UsageReport } from './schemasUsage';

/* ---------- Usage and plan (SPEC §18.1) ---------- */

/** `GET /usage-limits`: the org's plan, what it consumed this month, the percentages. */
export const getUsageLimits = (): Promise<UsageLimits> => api('GET', '/usage-limits', { schema: UsageLimits });

/** `GET /usage`: totals and the breakdown of a UTC month (the current one when omitted). */
export const getUsage = (month?: string): Promise<UsageReport> => api('GET', '/usage', { schema: UsageReport, ...(month ? { query: { month } } : {}) });

/** `GET /usage/export`: the month's CSV (one line per build, for invoicing). Org admins only. */
export const downloadUsageCsv = (month: string): Promise<Blob> => apiBlob(`/v1/usage/export?month=${encodeURIComponent(month)}`);
